/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import actionTypes from './Cart-ActionTypes';

export const updateCartSnapShot = (cart) => ({
    type: actionTypes.UPDATE_CART_SNAPSHOT,
    data: cart,
});

export const updateCart = (cart) => ({
    type: actionTypes.UPDATE_CART_SNAPSHOT,
    data: cart,
});

export const loadCart = (cart) => ({
    type: actionTypes.LOAD_CART,
    data: cart,
});

export const mfeGetCart = (orderId) => ({
    type: actionTypes.MFE_GET_CART,
    orderId,
});

export const cartLoaded = () => ({
    type: actionTypes.CART_LOADED,
});

export const callHandleCartFailure = (error) => ({
    type: actionTypes.CALL_HANDLE_CART_FAILURE,
    data: {
        error,
    },
});

export const callPrepareCart = () => ({
    type: actionTypes.CALL_PREPARE_CART,
});

export const callPrepareCartCompleted = () => ({
    type: actionTypes.CALL_PREPARE_CART_COMPLETED,
});
